// Single source of truth for the video tag vocabulary.
// Keep in sync with backend media/models.py VIDEO_CATEGORIES.
export const VIDEO_CATEGORIES = [
  "competition",
  "training",
  "liberty",
  "vet_inspection",
  "presentation",
  "sire",
  "dam",
  "jumping",
  "dressage",
  "other",
];
